import { DeviceFinder } from 'Guide/device_finder';
import { RelatedWikiForm } from 'Guide/WikiPages/related_wiki_form';
import { FrameModules } from 'Shared/frame_modules';

FrameModules.add('WikiRelatedFrameModule', () => {
   WikiRelatedFrameModule.initialize();
});

const WikiRelatedFrameModule = {
   initialize: function () {
      when($('wikiRelatedInput'), el => {
         DeviceFinder.initialize(el);
      });
      // The Edit toggle and save submit live with the module so they work
      // wherever it renders: the v1 sidebar and the v2 Metadata tab (which
      // doesn't load wiki_edit.js).
      when($('relatedWikiForm'), form => {
         RelatedWikiForm.initialize(form);
      });
   },
};
